import { memo } from 'react';
import { cn } from '@divlab/divanui';

import Img from '@UI/Img';
import styles from './IconVisa.module.css';
import icon from './visa.svg';

import type { FC, HTMLAttributes } from 'react';

export interface IconProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const IconVisa: FC<IconProps> = ({ className }) => {
  return (
    <Img
      src={icon}
      className={cn(styles.icon, className)}
      alt='Принимаем оплату банковскими картами Visa'
    />
  );
};

export default memo(IconVisa);
